export default theme => ({
  displayText: {
    fontSize: theme.textSizes[2],
    fontWeight: 500,
    display: "inline-block",
    whiteSpace: "pre-wrap",
  },
  displayText_icon: {
    display: "inline-block",
    verticalAlign: "middle",
    color: theme.palette.disabled.main,
    marginRight: 10,
  },
  displayText_text: {
    display: "inline-block",
    width: "100%",
  },
});
